<p>page-admin-buttons works!</p>
